// extracted by mini-css-extract-plugin
export default {"gallery":"Gallery_gallery__FvAYH","listItem":"Gallery_listItem__1GSTF","navigation":"Gallery_navigation__j64Tl"};